import { Component, HostListener, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
  standalone: true,
  selector: 'app-idle-timer',
  templateUrl: './idle-timer.component.html',
  styleUrls: ['./idle-timer.component.css'],
})
export class IdleTimerComponent {
  private _router = inject(Router);

  constructor() {
    this.setTimeout();
    this.userInactive.subscribe(() => {
      this._router.navigate(['/authentication/logout'], { queryParams: { returnUrl: '/' } });
    });
  }

  private activity: any;
  timeoutMilliseconds = 1800000;
  userInactive: Subject<any> = new Subject();

  setTimeout() {
    this.activity = setTimeout(() => this.userInactive.next(undefined), this.timeoutMilliseconds);
  }

  @HostListener('window:mousemove') refreshUserState() {
    clearTimeout(this.activity);
    this.setTimeout();
  }
}
